import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, share, switchMap } from 'rxjs';
import { GrantedAccessService } from '../../development/granted-access.service';
import { SharedActions } from '@states/shared/shared.action-types';
import { UtilsService } from '../../edge/utils.service';
import { GrantedAccessSchemaV2Actions } from '../states/granted-access-schema-v2/granted-access-schema-v2.actions';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { TranslateService } from '@ngx-translate/core';

const toSharedError = (utils: UtilsService, response: HttpErrorResponse | Error) =>
    SharedActions.showMessage({ error: utils.errMessage(response) });

export const loadGrantedAccessSchemaV2$ = createEffect(
    (
        actions$ = inject(Actions),
        grantedAccessService = inject(GrantedAccessService),
        utils = inject(UtilsService),
    ) =>
        actions$.pipe(
            ofType(GrantedAccessSchemaV2Actions.loadGrantedAccessSchemaV2),
            switchMap(() =>
                grantedAccessService.getGrantedAccessBySchemaVersion2().pipe(
                    switchMap((grantedAccessList) => [
                        GrantedAccessSchemaV2Actions.loadGrantedAccessSchemaV2Success({
                            grantedAccessList,
                        }),
                    ]),
                    catchError((response) => [
                        GrantedAccessSchemaV2Actions.loadGrantedAccessSchemaV2Fail(),
                        toSharedError(utils, response),
                    ]),
                ),
            ),
            share(),
        ),
    { functional: true },
);

export const revokeGrantedAccessSchemaV2Access$ = createEffect(
    (
        actions$ = inject(Actions),
        grantedAccessService = inject(GrantedAccessService),
        translateService = inject(TranslateService),
    ) =>
        actions$.pipe(
            ofType(GrantedAccessSchemaV2Actions.revokeAccess),
            switchMap(({ id }) =>
                grantedAccessService.revokeGrantedAccess(id).pipe(
                    switchMap((grantedAccess) => [
                        SharedActions.showMessage({ success: translateService.instant('TOASTS.ACCESS_REVOKED_SUCCESS') }),
                        GrantedAccessSchemaV2Actions.revokeAccessSuccess({
                            grantedAccess,
                        }),
                    ]),
                    catchError((response) => [
                        GrantedAccessSchemaV2Actions.revokeAccessFail(),
                    ]),
                ),
            ),
            share(),
        ),
    { functional: true },
)